import Dropdown, { DropdownItem, DropdownToggle } from 'Components/Molecules/DropdownLegacy';
import { useTranslation } from 'react-i18next';
import storage from 'Utils/storage';
import { updateProfile } from 'Services/user';
import { useUser } from 'Components/Organisms/UserProvider/useUser';

export default function LocaleSwitcher() {
    const { t, i18n } = useTranslation('common');
    const { user } = useUser();

    const languages = [
        {
            label: t('english'),
            value: 'EN',
        },
        {
            label: t('spanish'),
            value: 'ES',
        },
    ];

    function onSelectChange(language) {
        i18n.changeLanguage(language);
        storage.setItem('app-locale', language);
        if (user) {
            updateProfile({ language });
        }
    }

    const currentLanguage = languages.find(({ value }) => value === i18n.language).label;

    return (
        <Dropdown
            toggle={
                <DropdownToggle className="h-9">
                    <div className="min-w-18">{currentLanguage}</div>
                </DropdownToggle>
            }
        >
            {languages.map((period) => (
                <DropdownItem key={period.value} onClick={() => onSelectChange(period.value)}>
                    {period.label}
                </DropdownItem>
            ))}
        </Dropdown>
    );
}
